import jsPDF from "jspdf";
import logoGente from "../../../src/imagens/20191205 - Logo GENTE.png";
import logoPrefeitura from "../../../src/imagens/prefeitura_ouro_preto_logo_1.png";
import Api from "../../services/Api";

class PdfObra {
  static async gerarRelatorio(
    distrito,
    gerenciaPropriedade,
    maoDeObra,
    organizacao,
    obraMapImage,
    gerenciaPropriedadeImage,
    maoDeObraImage,
    organizacaoImage,
    assistenciaTecnicaImage,
  ) {
    const [
      propriedades,
      areaMedia,
      gerenciaPropriedadeData,
      maoDeObraData,
      organizacaoData,
      assistenciaTecnicaData,
    ] = await Promise.all([
      Api.getNumeroPropriedadesObra(
        distrito,
        gerenciaPropriedade,
        maoDeObra,
        organizacao,
      ),
      Api.getAreaMediaDistritoObra(
        distrito,
        gerenciaPropriedade,
        maoDeObra,
        organizacao,
      ),
      Api.getGerenciaPropriedade(distrito, null, maoDeObra, organizacao),
      Api.getMaoDeObra(distrito, gerenciaPropriedade, null, organizacao),
      Api.getOrganizacao(distrito, gerenciaPropriedade, maoDeObra, null),
      Api.getAssistenciaTecnica(
        distrito,
        gerenciaPropriedade,
        maoDeObra,
        organizacao,
      ),
    ]);

    const doc = new jsPDF();
    const imgSize = 64;

    this.gerarCabecalho(doc, logoGente, logoPrefeitura);
    this.pageOne(
      doc,
      distrito,
      propriedades.value,
      areaMedia.value,
      gerenciaPropriedade,
      maoDeObra,
      organizacao,
      obraMapImage,
    );

    doc.addPage();

    this.gerarCabecalho(doc, logoGente, logoPrefeitura);
    this.pageTwo(
      doc,
      propriedades.value,
      gerenciaPropriedadeData.value,
      maoDeObraData.value,
      organizacaoData.value,
      gerenciaPropriedadeImage,
      maoDeObraImage,
      organizacaoImage,
      imgSize,
    );

    doc.addPage();

    this.gerarCabecalho(doc, logoGente, logoPrefeitura);
    this.pageThree(doc, assistenciaTecnicaData.value, assistenciaTecnicaImage);

    const fileName =
      "Relatorio_Gestao-Mao_de_obra_" +
      distrito +
      "_" +
      this.dataAtual() +
      ".pdf";
    doc.save(fileName);
  }

  static pageOne(
    doc,
    distrito,
    propriedades,
    areaMedia,
    gerenciaPropriedade,
    maoDeObra,
    organizacao,
    obraMapImage,
  ) {
    // Considerações Iniciais
    doc.setFontSize(14);
    doc.setFont("helvetica", "bold");
    doc.text("Considerações iniciais", 10, 40);
    doc.setFontSize(12);
    doc.setFont("helvetica", "normal");
    const consideracoes = `      As informações e dados contidas no presente relatório foram extraídas através do dashboard oficial do Censo Agropecuário de Ouro Preto – MG. O Censo Agropecuário foi uma das principais etapas do Plano Municipal de Desenvolvimento Rural de Ouro Preto, projeto desenvolvido pela Secretaria Municipal de Agropecuária em parceria com a Universidade Federal de Viçosa. O objetivo central do Censo Agropecuário consistiu na busca de informações sobre os estabelecimentos e as atividades agropecuárias, caracterizando o produtor e o estabelecimento, a economia e emprego no meio rural, a pecuária, a lavoura e a agroindústria. Todo o processo foi realizado a partir da aplicação do Boletim de Cadastro Rural (BCR), formulário estruturado para caracterizar as propriedades, a infraestrutura rural, as condições socioeconômicas dos produtores e as atividades desenvolvidas. A seguir serão sintetizados alguns dados do Censo Agropecuário em formas de tabelas, gráficos e mapas.`;
    doc.text(consideracoes, 10, 50, { maxWidth: 180, align: "justify" });

    // Lista de condições e filtros
    doc.setFont("helvetica", "bold");
    doc.setFontSize(14);
    doc.text("Lista de condições e filtros aplicados", 10, 110);

    let y = 120;
    const filtros = [
      ["Distrito:", distrito || "Não informado"],
      ["Gerencia da propriedade: ", gerenciaPropriedade || "Não informado"],
      ["Mão de obra:", maoDeObra || "Não informado"],
      ["Organização:", organizacao || "Não informado"],
    ];

    doc.setFontSize(12);

    filtros.forEach(([label, valor]) => {
      // Marcador
      doc.setFont("helvetica", "normal");
      doc.text("\u2022", 10, y);

      // Label em negrito
      doc.setFont("helvetica", "bold");
      doc.text(label, 15, y);

      doc.setFont("helvetica", "normal");
      doc.text(String(valor), 15 + doc.getTextWidth(label) + 5, y);

      y += 6;
    });

    y += 5;
    // Indicadores
    doc.setFont("helvetica", "bold");
    doc.setFontSize(14);
    doc.text("Informações Gerais", 10, y);
    y += 10;

    const indicadores = [
      ["Propriedades:   ", propriedades],
      ["Área média:   ", areaMedia.toFixed(2)],
    ];

    doc.setFontSize(12);

    indicadores.forEach(([label, valor]) => {
      doc.setFont("helvetica", "normal");
      doc.text("\u2022", 10, y);

      doc.setFont("helvetica", "bold");
      doc.text(label, 15, y);

      doc.setFont("helvetica", "normal");
      doc.text(String(valor), 15 + doc.getTextWidth(label) + 2, y);

      y += 6;
    });

    y += 5;

    doc.addImage(obraMapImage, "PNG", 20, y, 100, 80); // aumenta um pouco pra ver
  }

  static pageTwo(
    doc,
    propriedades,
    gerenciaPropriedadeData,
    maoDeObraData,
    organizacaoData,
    gerenciaPropriedadeImage,
    maoDeObraImage,
    organizacaoImage,
    imgSize,
  ) {
    let y = 40;

    doc.addImage(
      gerenciaPropriedadeImage,
      "PNG",
      doc.internal.pageSize.getWidth() / 2 - imgSize/2,
      y,
      imgSize,
      imgSize,
    );

    y += imgSize + 5;

    doc.text(
      `      Em ${this.calcPercentual(gerenciaPropriedadeData["01 - Proprietário"], propriedades)}% das propriedades, a gerência é feita pelo próprio proprietário e ${this.calcPercentual(gerenciaPropriedadeData["02 - Gerente"], propriedades)}% possuem gerente. Outras ${this.calcPercentual(gerenciaPropriedadeData["03 - Outros"], propriedades)}% são gerenciadas de outras formas.`,
      10,
      y,
      { maxWidth: 180, align: "justify" },
    );

    y += 10;

    doc.addImage(
      maoDeObraImage,
      "PNG",
      doc.internal.pageSize.getWidth() / 2 - imgSize/2,
      y,
      imgSize,
      imgSize,
    );

    y += imgSize + 5;

    doc.text(
      `     Segundo os dados,  ${this.calcPercentual(maoDeObraData["01 - Própria"], propriedades)}% das propriedades possuem mão de obra própria e ${this.calcPercentual(maoDeObraData["02 - Familiar"], propriedades)}% familiar. O restante da mão de obra pode ser dividido em: ${this.calcPercentual(maoDeObraData["03 - Região"], propriedades)}% mão de obra da região e ${this.calcPercentual(maoDeObraData["04 - Outros Municípios"], propriedades)}% de outros municípios.`,
      10,
      y,
      { maxWidth: 180, align: "justify" },
    );

    y += 10;

    doc.addImage(
      organizacaoImage,
      "PNG",
      doc.internal.pageSize.getWidth() / 2 - imgSize/2,
      y,
      imgSize,
      imgSize,
    );

    y += imgSize + 5;

    doc.text(
      `      ${this.calcPercentual(organizacaoData["04 - Não Participo"], propriedades)}% das propriedades não participam de nenhum tipo de organização. Entre as participantes, ${this.calcPercentual(organizacaoData["01 - Associação"], propriedades)}% são de associação, ${this.calcPercentual(organizacaoData["02 - Cooperativa"], propriedades)}% de cooperativa e ${this.calcPercentual(organizacaoData["03 - Sindicato"], propriedades)}% de sindicato.`,
      10,
      y,
      { maxWidth: 180, align: "justify" },
    );
  }

  static pageThree(doc, assistenciaTecnicaData, assistenciaTecnicaImage) {
    let y = 40;

    doc.addImage(
      assistenciaTecnicaImage,
      "PNG",
      doc.internal.pageSize.getWidth() / 2 - 50,
      y,
      100,
      150,
    );

    y += 160;

    doc.text(
      `      Observou-se que a maior parte dos entrevistados, ${assistenciaTecnicaData['01 - Não']}, declarou não utilizar assistência técnica, reforçando a ausência de suporte técnico especializado na rotina produtiva. Entre os que afirmaram utilizar algum tipo de serviço, destacam-se EMATER–MG (${assistenciaTecnicaData['06 - EMATER - MG']}), prefeituras (${assistenciaTecnicaData['11 - Prefeituras']}) e profissionais liberais (${assistenciaTecnicaData['09 - Profissional Liberal']}). Em menor quantidade aparecem sindicatos(${assistenciaTecnicaData['02 - Sindicatos']}), Outras instituições(${assistenciaTecnicaData['12 - Outras']}), EPAMIG(${assistenciaTecnicaData['10 - EPAMIG']}), cooperativas(${assistenciaTecnicaData['04 - Cooperativas']}), empresas privadas(${assistenciaTecnicaData['03 - Empresas Privadas']}), EMBRAPA(${assistenciaTecnicaData['07 - EMBRAPA']}) e ONGs(${assistenciaTecnicaData['05 - ONGs']}), evidenciando baixa inserção dos produtores em redes de apoio técnico.`,
      10,
      y,
      { maxWidth: 180, align: "justify" },
    );
  }

  static calcPercentual(val, total) {
    const res = (val / total) * 100;
    return res.toFixed(2);
  }

  static gerarCabecalho(doc, logoEsq, logoDir) {
    // Logo à esquerda
    if (logoEsq) {
      doc.addImage(logoEsq, "PNG", 10, 10, 30, 20);
    }

    // Logo à direita
    if (logoDir) {
      doc.addImage(logoDir, "PNG", 170, 10, 30, 15);
    }

    // Título central
    doc.setFontSize(14);
    doc.text(
      "Relatório de gestão/mão de obra das propriedades",
      doc.internal.pageSize.getWidth() / 2,
      15,
      { align: "center" },
    );
    doc.text(
      "rurais cadastradas no censo agropecuário",
      doc.internal.pageSize.getWidth() / 2,
      21,
      { align: "center" },
    );

    // Informações extras
    doc.setFontSize(8);
    doc.text(`Data: ${new Date().toLocaleDateString()}`, 170, 28);

    // Linha divisória
    doc.setDrawColor(150);
    doc.line(10, 32, 200, 32);
  }

  static dataAtual() {
    const hoje = new Date();

    const data = hoje.toLocaleDateString("pt-BR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });

    const formatada = data.replace(/\//g, "_");

    return formatada;
  }
}

export default PdfObra;
